var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRpm = function SvgRpm(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4222",
    width: 16,
    height: 16,
    viewBox: "0 0 15 15",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1037.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4841",
    fill: "currentColor",
    d: "M6.333 1039.2a.333.333 0 0 0-.334.334v.999c0 .185.153.373.334.334H7.5v.666h1.833v-.666H10.5a.333.333 0 0 0 .333-.334v-1a.333.333 0 0 0-.333-.333zm-.306 2.25c-.456.01-.484.173-.651.369l-1.296 1.463h-.747a.83.83 0 0 0-.833.833v3.75c0 .462.372.834.833.834h.839l1.181 1.386c.197.217.284.365.58.365h3.8c.33 0 .496-.11.71-.324l2.184-2.145c.256-.256.29-.405.29-.658v-.457h.416v1.167c0 .185.15.334.334.334h1a.333.333 0 0 0 .333-.334v-4.666a.333.333 0 0 0-.334-.334h-1a.333.333 0 0 0-.333.334v1.165h-.416v-2.25a.83.83 0 0 0-.834-.833h-.997zm-5.693 1.832a.333.333 0 0 0-.334.334v4.666c0 .185.149.334.334.334h.999a.333.333 0 0 0 .334-.334v-1.416h1.84v-1.75h-1.84v-1.5a.333.333 0 0 0-.334-.334z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRpm);
export default ForwardRef;